import { render, staticRenderFns } from "./SalarayVariants.vue?vue&type=template&id=c0d3a83a&"
import script from "./SalarayVariants.vue?vue&type=script&lang=js&"
export * from "./SalarayVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports